module.exports = __webpack_public_path__ + "static/media/chicken.72448ec7.png";